import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  defaultValueInputLabel: {
    id: 'field-settings-menus.default-value-input.label.non-final',
    defaultMessage: 'Default value',
    description: 'Label for the input used to set a default value for a field.'
  },
  defaultValueInputHelper: {
    id: 'field-settings-menus.default-value-input.helper.non-final',
    defaultMessage: 'Value will be added to new entries',
    description:
      'Helper text shown below a field default value input after a value is entered.'
  },
  defaultValueInputPlaceholder: {
    id: 'field-settings-menus.default-value-input.placeholder.non-final',
    defaultMessage: 'Add a default value',
    description: 'Placeholder text for a default value input when no value is set.'
  },
  attachmentDisplayFormatLabel: {
    id: 'field-settings-menus.attachment-display-format.label.non-final',
    defaultMessage: 'Display format',
    description: 'Section label for choosing how attachment field media is displayed.'
  },
  entryLinkDisplaySourceLabel: {
    id: 'field-settings-menus.entry-link-display-source.label.non-final',
    defaultMessage: 'Display entry link from',
    description:
      'Section label for choosing which database an entry link field displays entries from.'
  },
  jiraDetailsDisplaySourceLabel: {
    id: 'field-settings-menus.jira-details-display-source.label.non-final',
    defaultMessage: 'Display Jira link details from',
    description:
      'Section label for choosing which Jira link field a Jira details field displays details from.'
  },
  jiraDetailsDisplayedLabel: {
    id: 'field-settings-menus.jira-details-displayed.label.non-final',
    defaultMessage: 'Jira detail displayed',
    description:
      'Section label for choosing which Jira detail a Jira details field displays.'
  },
  smartLinkDisplayAsLabel: {
    id: 'field-settings-menus.smart-link-display-as.label',
    defaultMessage: 'Display as',
    description: 'Label for choosing how a Smart Link field value is displayed.'
  },
  smartLinkDisplayUrl: {
    id: 'field-settings-menus.smart-link-display-as.url',
    defaultMessage: 'URL',
    description: 'Option to display a Smart Link field value as a URL.'
  },
  smartLinkDisplayInline: {
    id: 'field-settings-menus.smart-link-display-as.inline',
    defaultMessage: 'Inline',
    description: 'Option to display a Smart Link field value as an inline Smart Link.'
  },
  defaultValueModeNoDefault: {
    id: 'field-settings-menus.default-value-mode.no-default.non-final',
    defaultMessage: 'No default',
    description: 'Option label for disabling a field default value.'
  },
  defaultValueModeCurrentUser: {
    id: 'field-settings-menus.default-value-mode.current-user.non-final',
    defaultMessage: 'Current user',
    description:
      'Option label for setting the current user as the default value for a user field.'
  },
  defaultValueModeSpecificUser: {
    id: 'field-settings-menus.default-value-mode.specific-user.non-final',
    defaultMessage: 'Specific user',
    description:
      'Option label for choosing a specific user as the default value for a user field.'
  },
  fieldSettingsNotifyUsersSectionLabel: {
    id: 'field-settings-menus.notify-users-section.label.non-final',
    defaultMessage: 'Notify users',
    description: 'Section label for notifying users in the user field settings menu.'
  },
  sendNotificationsToggleLabel: {
    id: 'field-settings-menus.send-notifications-toggle.label.non-final',
    defaultMessage: 'Send notifications',
    description: 'Label for the toggle that enables user mention notifications.'
  },
  allowMultiToggleSectionLabel: {
    id: 'field-settings-menus.allow-multi-toggle.section-label',
    defaultMessage: 'Allow multiple',
    description: 'Section label for settings that limit field values.'
  },
  allowMultiToggleLabelTags: {
    id: 'field-settings-menus.allow-multi-toggle-tags.label',
    defaultMessage: 'Allow multiple tags',
    description: 'Label for the toggle that enables multiple tags for a tag/select field.'
  },
  allowMultiToggleLabelUsers: {
    id: 'field-settings-menus.allow-multi-toggle-users.label',
    defaultMessage: 'Allow multiple users',
    description: 'Label for the toggle that enables multiple users for a user field.'
  },
  allowMultiToggleLabelLinks: {
    id: 'field-settings-menus.allow-multi-toggle-links.label',
    defaultMessage: 'Allow multiple links',
    description:
      'Label for the toggle that enables multiple links for a Confluence, Jira, or Entry link field.'
  },
  allowMultiToggleTooltipTags: {
    id: 'field-settings-menus.allow-multi-toggle-tags.tooltip',
    defaultMessage:
      'Allowing multiple tags will prevent or remove grouping by this field.',
    description:
      'Tooltip explaining that enabling multiple tags disables grouping by that field.'
  },
  allowMultiToggleTooltipUsers: {
    id: 'field-settings-menus.allow-multi-toggle-users.tooltip',
    defaultMessage:
      'Allowing multiple users will prevent or remove grouping by this field.',
    description:
      'Tooltip explaining that enabling multiple users disables grouping by that field.'
  }
});
